import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { OpenDialogDeleteElementComponent } from 'app/components/dialog/open-dialog-delete-element/open-dialog-delete-element.component';
import { FormDefinition } from 'app/shared/models/class/forms/form-definition';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { FormService } from 'app/shared/services/forms/form.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { Router } from '@angular/router';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-admin-forms',
  templateUrl: './admin-forms.component.html',
  styleUrls: ['./admin-forms.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdminFormsComponent extends SubscriptionBaseComponent implements OnInit {

  displayedColumns: string[] = ['createdOn', 'name', 'description', 'details'];
  dataSource!: MatTableDataSource<FormDefinition>;
  valueInput: string = '';
  searchForm!: UntypedFormGroup;
  isLoading = false;
  // forms: FormSubscription[] = [];
  formDefinitions: FormDefinition[] = [];
  openForm = false;
  formToEdit!: FormDefinition;

  pageSize = 50;
  pageSizeOptions: number[] = [50, 100, 150];
  pageEvent!: PageEvent;
  color: ThemePalette = 'primary';

  @ViewChild(MatSort, { static: false }) sort!: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;

  constructor(
    private readonly faIconService: FaiconService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly dialog: MatDialog,
    private readonly formService: FormService,
    private readonly _cdr: ChangeDetectorRef
  )
  {
    super();
    this.dataSource = new MatTableDataSource(this.formDefinitions);
  }

  ngOnInit(): void {
    this.initForm();
    this.init();
    this.initSub();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  applyFilter(filterValue: any): void {
    this.valueInput = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  resetSearch(): void {
    this.searchForm.get('keyword')?.setValue('');
    this.valueInput = '';
    this.applyFilter(this.valueInput);
  }

  onGetOpenForm(value: any): void {
    this.openForm = value.bool;
    if (value.key) {
      this.init();
    }
  }

  addForm(): void {
    this.openForm = true;
    this.formToEdit = null as any;
  }

  edit(element: FormDefinition): void {
    this.formService.getFormDefinitionByKey(element.key!).subscribe({
      next: (data: FormDefinition) => {
        this.openForm = true;
        this.formToEdit = data;
      }
    });
  }

  deleteFD(fs: FormDefinition): void {
    const params = {
      disableClose: true,
      data: {
        title: `Suppression d'un formulaire `,
        text: `Êtes-vous sûr de vouloir supprimer le formulaire "${fs.name}" ?`,
        id: fs.key,
        action: 'deleteFormDefinition'
      }
    };
    const dialogRef = this.dialog.open(OpenDialogDeleteElementComponent, params);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.formDefinitions = this.formDefinitions.filter(fd => fd.key !== fs.key);
        this.initDataSource(this.formDefinitions);
      }
    });

  }

  activatedOrDeactivatedFD(event: MatSlideToggleChange, fs: FormDefinition): void {
    this.formService.getFormDefinitionByKey(fs.key!).subscribe({
      next: (data: FormDefinition) => {
        let message = data.enabled ? `Êtes-vous sûr de vouloir désactiver le formulaire ${data.name} ?` : `Êtes-vous sûr de vouloir activer le formulaire ${data.name} ?`;
        const params = {
          disableClose: true,
          data: {
            title: data.enabled ? `Désactivation du formulaire` : `Activation du formulaire`,
            text: message,
            id: data.key,
            action: 'activateOrDeactivateFD',
            form: data
          }
        };
        const dialogRef = this.dialog.open(OpenDialogDeleteElementComponent, params);
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.init();
          } else {
            // the toggle already flipped its internal state on click, revert it since the change was cancelled
            event.source.checked = data.enabled;
            this._cdr.detectChanges();
          }
        });

      }
    });
  }

  private initSub(): void {
    this.subscription.add(
      this.formService.isSubscriptionAdded$.subscribe((value: boolean) => {
        if (value) {
          this.init();
        }
      })
    );
  }

  private init(): void {
    this.formService.getFormDefinition().subscribe({
      next: (formDefinitions: FormDefinition[]) => {
        this.formDefinitions = formDefinitions;
        this.initDataSource(this.formDefinitions);
      },
      error: (err: any) => {
        console.error('Error fetching form definitions', err);
      }
    });
  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }

  private initDataSource(formDefinitions: FormDefinition[]): void {
    this.dataSource = new MatTableDataSource(formDefinitions);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

}
